var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"text-dark-text-100 dark:text-light-text-100 text-heading-3 mt-6 mb-4 tablet-portrait:mb-5 ps-1 tablet-portrait:ps-4 tablet-portrait:pe-2"},[_c('h1',{staticClass:"whitespace-normal"},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('h2',{staticClass:"font-semibold"},[_vm._v(_vm._s(_vm.subtitle))])])
}
var staticRenderFns = []

export { render, staticRenderFns }